import React from "react";
import {
  Wheat,
  ClipboardList,
  Scale,
  BadgeCheck,
  IndianRupee,
  Warehouse,
  Truck,
  MapPin
} from "lucide-react";
const processSteps = [
  {
    title: "Farmer Brings the Produce",
    image: "/Images/TVM Region (2).jpg",
  },
  {
    title: "Registration & Token Issue",
    image: "/Images/TVM Region (2).jpg",
  },
  {
    title: "Weighing & Quality Assessment",
    image: "/Images/TVM Region (2).jpg",
  },
  {
    title: "Price Determination / Auction",
       image: "/Images/TVM Region (2).jpg",
  },
  {
    title: "Payment to Farmers",
     image: "/Images/TVM Region (2).jpg",
  },
  {
    title: "Storage & Logistics",
      image: "/Images/TVM Region (2).jpg",
  },
  {
    title: "Distribution to Buyers",
      image: "/Images/TVM Region (2).jpg",
  },
];


const Agrimarketing = () => {
  return (
    <div className="w-full bg-white">

      {/* ===== Header (IMAGE STYLE) ===== */}
      <div className="w-full border-b border-gray-200">
        <div className="max-w-7xl mx-auto py-6 text-center">
          <h1 className="text-3xl font-semibold text-blue-900">
            Agri Marketing Societies
          </h1>
        </div>
      </div>

      {/* ===== Overview (IMAGE STYLE) ===== */}
      <section className="w-full mx-auto px-6 py-10">
        <div className="bg-[#f1f7ff] rounded-xl p-8">

          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Overview
          </h2>

          <div className="flex gap-4">
            {/* Left blue indicator */}
            <div className="w-1 bg-blue-600 rounded-full mt-1"></div>

            <div>
              <p className="text-gray-800 leading-relaxed mb-4">
                Agri Marketing Societies are farmer-centric institutions under the
                Cooperative Department that support farmers by providing fair,
                transparent, and efficient market linkages.
              </p>
              <p className="text-gray-800 leading-relaxed">
                They act as the bridge between farmers and buyers, ensuring that
                agricultural produce reaches the market safely, scientifically,
                and profitably.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* ===== Highlight Message ===== */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-8 text-center">
            <h3 className="text-2xl font-semibold text-blue-800 mb-3">
              Empowering Farmers, Strengthening Local Economies
            </h3>
            <p className="text-gray-700 max-w-4xl mx-auto">
              Agri Marketing Societies help farmers secure better prices, reduce
              distress sales, and connect Tamil Nadu’s rural economy to larger
              markets, all while maintaining transparency and trust.
            </p>
          </div>
        </div>
      </section>

      {/* ===== Banner Placeholder ===== */}
      <section className="py-12 px-6 bg-[#f4f8ff]">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-md bg-blue-100 h-72 flex items-center justify-center text-blue-700 font-semibold text-lg">
            Farmer → Weighing & Quality Check → Marketplace
          </div>
        </div>
      </section>

{/* ===== Connected Process Flow (Grid Layout) ===== */}
<section className="py-20 px-6 bg-[#f4f8ff] w-full">
  <div className="max-w-7xl mx-auto w-full">
    <h2 className="text-4xl font-bold text-gray-900 mb-20 text-center">
      How Agri Marketing Societies Work
    </h2>

    {/* First Row: 4 Images */}
    <div className="grid grid-cols-1 sm:grid-cols-4 gap-10 mb-20 w-full">
      {processSteps.slice(0, 4).map((step, index) => (
        <div key={index} className="flex flex-col items-center relative w-full">
          {/* Number Badge */}
          <div className="absolute -top-4 -left-4 z-10 bg-blue-600 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold text-lg shadow-lg">
            {index + 1}
          </div>

          {/* Image */}
          <div className="w-56 h-56 bg-white rounded-xl overflow-hidden shadow-xl border">
            <img
              src={step.image}
              alt={step.title}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Title */}
          <p className="mt-6 text-lg font-semibold text-center text-gray-900">
            {step.title}
          </p>
        </div>
      ))}
    </div>

    {/* Second Row: 3 Images Centered */}
    <div className="flex justify-center gap-10 w-full">
      {processSteps.slice(4, 7).map((step, index) => (
        <div key={index} className="flex flex-col items-center relative w-56">
          {/* Number Badge */}
          <div className="absolute -top-4 -left-4 z-10 bg-blue-600 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold text-lg shadow-lg">
            {index + 5}
          </div>

          {/* Image */}
          <div className="w-56 h-56 bg-white rounded-xl overflow-hidden shadow-xl border">
            <img
              src={step.image}
              alt={step.title}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Title */}
          <p className="mt-6 text-lg font-semibold text-center text-gray-900">
            {step.title}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>



 {/* Store Locations */}
      <section className="w-full px-6 sm:px-10 lg:px-20 py-14">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">
          Store Locations
        </h2>
        <div className="bg-white rounded-lg shadow-md border overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-[60%_40%]">
            {/* Map Section */}
            <div className="h-[400px] lg:h-[500px] relative">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125384.30132503736!2d76.95318444999999!3d11.0168445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af2f971cb5%3A0x2fc1c81e183ed282!2sCoimbatore%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Fair Price Shop Locations"
              ></iframe>
            </div>

            {/* Filter Section */}
            <div className="bg-white p-6 border-l border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">District</h3>
              <select className="border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full text-base mb-6">
                <option>Select District</option>
                <option>Coimbatore</option>
                <option>Chennai</option>
                <option>Madurai</option>
                <option>Salem</option>
                <option>Tiruchirappalli</option>
                <option>Tirunelveli</option>
                <option>Erode</option>
                <option>Vellore</option>
              </select>

              <h3 className="text-lg font-semibold text-gray-800 mb-4">Select Block</h3>
              <select className="border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full text-base mb-6">
                <option>Select Block</option>
                <option>Primary Cooperative Society</option>
                <option>Urban Cooperative Society</option>
                <option>Rural Cooperative Society</option>
                <option>Consumer Cooperative</option>
              </select>

              <button className="bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors w-full text-base font-medium flex items-center justify-center gap-2">
                <MapPin className="w-4 h-4" />
                FILTER
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Agrimarketing;
